import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  ACTION_GET_REQUESTING,
  ACTION_GET_SUCCESS,
  ACTION_GET_ERROR,
  COFFEE_GET_SETTINGS_SUCCESS,
  COFFEE_MODIFY_SETTINGS_ERROR,
  COFFEE_GET_SETTINGS_ERROR,
  COFFEE_MODIFY_SETTINGS_SUCCESS,
  COFFEE_MODIFY_SETTINGS_REQUESTING,
  COFFEE_GET_SETTINGS_REQUESTING
} from "./constants";

import { fetchApi } from "../api";

const apiEndpoints = {
  getSettings: "/v1/random-coffee/settings/", // clientId
  modifySettings: "/v1/random-coffee/settings"
};

const getSettingsApi = data => {
  return fetchApi(apiEndpoints.getSettings + data, {}, "get");
};

const modifySettingsApi = data => {
  return fetchApi(apiEndpoints.modifySettings, data, "patch");
};

function* getSettingsFlow(action) {
  try {
    const result = yield call(getSettingsApi, action.payload);
    yield put({ type: COFFEE_GET_SETTINGS_SUCCESS, payload: result });
  } catch (error) {
    console.log(error);
    yield put({ type: COFFEE_GET_SETTINGS_ERROR, payload: error });
  }
}

function* modifySettingsFlow(action) {
  try {
    const result = yield call(modifySettingsApi, action.payload);
    yield put({ type: COFFEE_MODIFY_SETTINGS_SUCCESS, payload: result });
  } catch (error) {
    console.log(error);
    yield put({ type: COFFEE_MODIFY_SETTINGS_ERROR, payload: error });
  }
}

function* Saga() {
  yield all([
    takeLatest(COFFEE_MODIFY_SETTINGS_REQUESTING, modifySettingsFlow),
    takeLatest(COFFEE_GET_SETTINGS_REQUESTING, getSettingsFlow)
  ]);
}

export default Saga;
